import { Link } from 'react-router-dom'
import { eda } from '../../../assets'
import '../Project.css'

export default function EDA() {

  window.scrollTo(0, 0)

  return (
    <>
      <div className='project-wrapper'>
        <div className="project-container">
          <div className='project-image-container'>
            <img src={eda} className='project-image'
            alt='Used Bikes EDA' />
          </div>
          <div className='project-title'>
            <h1>Used Bike Prices</h1>
          </div>
          <div className='project-description'>
            <p>In this Jupyter Notebook, various EDA techniques are used to gain insights about India's used motorcyle market. After some data visualization, pipelines are used to preprocess the data before training a regression model for predictions.</p>
          </div>
          <div className='project-links'>
            <Link to='https://chart-studio.plotly.com/~owenjrjones/2.embed'
              target='_blank'
              rel='noreferrer'
            >
              <i className='fas fa-external-link-alt'>&nbsp;</i>
              Notebook
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
